export enum FinancialTransactionTypeEnum {
    CREDIT = 'CREDIT',
    DEBIT = 'DEBIT',
}
export enum FinancialTransactionTypeLabelEnum {
    CREDIT = 'Receita',
    DEBIT = 'Despesa',
}
